import React from 'react';
import { useIntl, history } from 'umi';
import { inject, observer } from 'mobx-react';
import { Icon, message, Modal } from '@/components';
import { RootStore } from '@/models';
import ActionBtn, { ActionProps } from '../ActionBtn';
import styles from './index.less';
import classNames from 'classnames';
import { elkLog } from '@/utils/elkReport';

interface Props extends Partial<Pick<RootStore, 'rtc' | 'user' | 'simultaneousInterpretation'>> {
  RTCInstance?: RootStore['rtc'];
  user?: RootStore['user'];
  simultaneous?: RootStore['simultaneousInterpretation'];
  meetingId: string;
}
const LeaveBtn: React.FC<Props> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
    user: store.user,
    simultaneous: store.simultaneousInterpretation,
  };
})(
  observer((props) => {
    const { RTCInstance, user, simultaneous, meetingId } = props;
    const { formatMessage } = useIntl();

    const HangUp = React.useCallback(() => {
      Modal.confirm({
        title: formatMessage({ id: 'CONFIRM_LEAVE' }),
        okText: formatMessage({ id: 'LEAVE' }),
        cancelText: formatMessage({ id: 'CANCEL' }),
        // transitionName: '',
        okButtonProps: {
          className: `popo-meeting-button`,
          danger: true,
        },
        onOk: async () => {
          try {
            await user?.logout(meetingId);
            setTimeout(() => {
              RTCInstance && RTCInstance.destroy();
              // 开启了同传 要退出子房间
              if (simultaneous && simultaneous.interpretationStatus === 2) {
                simultaneous.destroy();
              }
            }, 500);
            elkLog('离开会议成功');
          } catch (err: any) {
            if (err.message) {
              message.warning({
                content: err.message,
                noIcon: true,
              });
            }
            elkLog('离开会议失败', {}, err);
          }
          history.replace({
            pathname: `feedback`,
          });
        },
      });
    }, [RTCInstance, meetingId, user]);

    return (
      <ActionBtn
        bottomTitle={formatMessage({ id: 'LEAVE' })}
        className={classNames(styles.leaveBtn, styles.red)}
        onClick={HangUp}
      >
        <Icon className={styles.icon} name="icon-hangup" />
      </ActionBtn>
    );
  })
);

export default LeaveBtn;
